<template>
  <CalculationElementLayout
    :child-elements="['material', 'labour', 'machine', 'part']"
    :node-id="nodeId"
    manufacturing-step>
    <ManufacturingStepTabs :node-id="nodeId" />
  </CalculationElementLayout>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { useTranslation } from "i18next-vue";
import { useRoute } from "vue-router";

import { useCommonRules } from "@/validations/common";

import ManufacturingStepTabs from "./ManufacturingStepTabs.vue";
import { useSpaceStore } from "../../../stores/spaceStore";
import CalculationElementLayout from "@/layouts/CalculationElementLayout.vue";

const { t } = useTranslation();
const spaceStore = useSpaceStore();
const route = useRoute();
const { required } = useCommonRules(t);

const manufacturingStepNodeId = computed(() => route.params.nodeId);

const nodeId = computed({
  get() {
    return manufacturingStepNodeId.value
      ? manufacturingStepNodeId.value.split("_")[0] + "_part"
      : null;
  },
  set(value) {
    manufacturingStepNodeId.value = value;
  }
});
const valid = ref(false);
const manufacturingStep = ref(null);

onMounted(() => {
  manufacturingStep.value = spaceStore.getElement(nodeId);
});
</script>
